"use client"

import { ColumnDef } from "@tanstack/react-table"
import { Button } from "@/components/shadcn/button"
import { Download } from "lucide-react"
import { TFunction } from "i18next"
import httpFetch from "@/lib/http"

// 记忆库数据类型
export type MemoryLibrary = {
  id: string
  count: number
}

// 创建列定义的函数，接受翻译函数作为参数
export const createMemoryLibrariesColumns = (t: TFunction): ColumnDef<MemoryLibrary>[] => [
  {
    accessorKey: "id",
    header: () => (
      <div className="font-semibold text-foreground">{t('memoryVaults.table.vaultId')}</div>
    ),
    cell: ({ row }) => (
      <code className="text-xs">{row.getValue("id")}</code>
    ),
  },
  {
    accessorKey: "count",
    header: () => (
      <div className="font-semibold text-foreground">{t('memoryVaults.table.totalMessages')}</div>
    ),
    cell: ({ row }) => {
      const count = row.getValue("count") as number
      return <div className="text-left">{count.toLocaleString()}</div>
    },
  },
  {
    id: "export",
    header: () => (
      <div className="font-semibold text-foreground">{t('memoryVaults.table.actions')}</div>
    ),
    cell: ({ row }) => {
      const libraryId = row.getValue("id") as string
      return (
        <div className="text-left">
          <Button 
            variant="outline"
            size="sm"
            className="h-8 px-3 text-xs" 
            onClick={async (e) => {
              e.stopPropagation() // 阻止事件冒泡到行点击
              try {
                const url = `/api/v1/memory-lib/query/export-conversations?memory_id=${encodeURIComponent(libraryId)}`
                const res = await httpFetch(url, { method: 'POST' })
                if (!res.ok) throw new Error(t('memoryVaults.export.error'))
                const blob = await res.blob()
                const objectUrl = URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = objectUrl
                a.download = `memory_vault_${libraryId}_export.json`
                a.click()
                a.remove()
                URL.revokeObjectURL(objectUrl)
              } catch (error) {
                console.error(t('memoryVaults.export.error'), error)
              }
            }}
          >
            <Download className="h-3 w-3 mr-1" />
            {t('memoryVaults.table.export')}
          </Button>
        </div>
      )
    },
  },
]

// 为了向后兼容，保留原来的导出（但建议使用新的函数）
export const memoryLibrariesColumns: ColumnDef<MemoryLibrary>[] = []
